import type { Chunk } from './types.js';

/**
 * Size-bounded, line-tracked chunker. Pragmatic for Phase 2 (keeps the package
 * pure-JS, no WASM grammars); the planned upgrade is symbol-aware splitting via
 * web-tree-sitter (D5) behind this same function signature.
 */
const MAX_CHARS = 1600;
const SOFT_MIN_CHARS = 600;

export function chunkFile(path: string, content: string): Chunk[] {
  const lines = content.split('\n');
  const chunks: Chunk[] = [];
  let startLine = 1;
  let buf: string[] = [];
  let size = 0;

  const flush = (endLine: number): void => {
    if (buf.length === 0) return;
    const text = buf.join('\n').trim();
    if (text.length > 0) {
      chunks.push({ id: `${path}:${startLine}-${endLine}`, path, startLine, endLine, text });
    }
    buf = [];
    size = 0;
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i] ?? '';
    buf.push(line);
    size += line.length + 1;
    const lineNo = i + 1;
    const blank = line.trim().length === 0;
    // Prefer to break at a blank line once past the soft minimum; hard-break at the cap.
    if ((blank && size >= SOFT_MIN_CHARS) || size >= MAX_CHARS) {
      flush(lineNo);
      startLine = lineNo + 1;
    }
  }
  flush(lines.length);
  return chunks;
}
